// APPLICATION ENTRY POINT
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';
import './insa-custom-scripts/layout';

import './images.ts';

enableProdMode();

const desktopTheme = localStorage.getItem('desktopTheme') || 'simple';

if (process.env.INSA_DESKTOP) {
  require('../insa-css/insa-clients/Insa/insa-kendo-css/kendo.custom.css');
  let desktopDataviz = require('../insa-css/insa-clients/Insa/insa-kendo-css/kendo.' + desktopTheme + '.dataviz');
  desktopDataviz.registerKendoTheme();
  require('../insa-css/style.css');
  console.log('Loading desktop theme: ' + desktopTheme);
  switch (desktopTheme) {
    case 'simple':
      const simpleCSS = require('../insa-css/insa-clients/Insa/css/simple.css');
      simpleCSS.use();
      break;
    case 'classic':
      const classicCSS = require('../insa-css/insa-clients/Insa/css/classic.css');
      classicCSS.use();
      break;
    case 'test':
      const testCSS = require('../insa-css/insa-clients/Insa/css/test.css');
      testCSS.use();
      break;
  }
} else if (process.env.INSA_CLIENT && process.env.INSA_CLIENT !== '') {
  console.log('Loading '  + process.env.INSA_CLIENT + ' application style');
  require('../insa-css/insa-clients/' + process.env.INSA_CLIENT + '/insa-kendo-css/kendo.custom.css');
  require('../insa-css/style.css');
  // require('../insaweb-css/kendo.custom.css');
  require('../insa-css/insa-clients/' + process.env.INSA_CLIENT + '/css/custom.css');
  let customDataviz = require('../insa-css/insa-clients/' + process.env.INSA_CLIENT + '/insa-kendo-css/kendo.custom.dataviz');
  customDataviz.registerKendoTheme();
} else {
  // load standard config files and styles
  require('../insa-css/insa-kendo-css/kendo.custom.css');
  require('../insa-css/style.css');
  require('../insa-css/custom.css');
  let standardDataviz = require('../insa-css/insa-kendo-css/kendo.custom.dataviz');
  standardDataviz.registerKendoTheme();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./app/main.ts